<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-row class="text item">
          <el-form-item prop="name"
                        label="客户名称:">
            <el-input v-model="form.name"
                      placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item prop="number"
                        label="客户编号:">
            <el-input v-model="form.number"
                      placeholder="请输入客户编号"
                      type="number"
                      :disabled="true"></el-input>
          </el-form-item>
          <el-form-item prop="phone"
                        label="联系方式:">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item prop="email"
                        label="邮箱:">
            <el-input v-model="form.email"
                      type="email"></el-input>
          </el-form-item>
          <el-form-item prop="detail"
                        label="描述:">
            <el-input type="textarea"
                      placeholder="请输入描述"
                      v-model="form.detail">
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary"
                     native-type="submit">保存
          </el-button>
          <router-link :to="{ path: '/teke_customer/table'}">
            <el-button type="primary">取消</el-button>
          </router-link>
        </el-row>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { searchRules } from '../tekeCustomer.rules.js'

export default {
  data () {
    return {
      searchRules,
      selectLoading: false,
      form: {
        id: this.$route.params.id,
        name: null,
        number: null,
        phone: null,
        email: null,
        detail: null,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.page('getTekeCustomer', this.form.id).then(({data}) => {
      filter.setLoop(this.form, data)
    })
  },
  methods: {
    ...Vuex.mapActions(['editTekeCustomer', 'getTekeCustomer']),

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          return request.common('editTekeCustomer', this.form).then((data) => {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/teke-customer/pages/TekeCustomerUpdate.vue